import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('pricing_countdown_end') : null;
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      if (remaining > 0) return remaining;
    }
    const end = Date.now() + 24 * 60 * 60 * 1000;
    if (typeof window !== 'undefined') localStorage.setItem('pricing_countdown_end', end.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const cuposPercentage = 71;
  return <section className="w-full bg-white py-8 md:py-16" data-id="element-149">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-151">
          <div className="text-center mb-6 md:mb-10" data-id="element-152">
            <div className="bg-red-50 border border-red-200 rounded-2xl p-6 md:p-10 max-w-3xl mx-auto" data-id="element-153">
              <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-6 md:mb-8" data-id="element-154">
                ⏰ PRECIO DE LANZAMIENTO — OFERTA LIMITADA
              </h2>

              <div className="flex items-center justify-center gap-2 md:gap-4 mb-6 md:mb-8" data-id="element-155">
                {[{
                value: pad(hours),
                label: 'HS'
              }, {
                value: pad(minutes),
                label: 'MIN'
              }, {
                value: pad(seconds),
                label: 'SEG'
              }].map((unit, index) => <Fragment key={unit.label} data-id="element-156">
                    {index > 0 && <span className="text-4xl md:text-7xl font-bold text-red-500 -mt-4 md:-mt-6" data-id="element-157">
                        :
                      </span>}
                    <div className="flex flex-col items-center" data-id="element-158">
                      <motion.span key={unit.value} initial={{
                    scale: 1.1,
                    opacity: 0.7
                  }} animate={{
                    scale: 1,
                    opacity: 1
                  }} transition={{
                    duration: 0.2
                  }} className="text-5xl md:text-8xl font-bold text-red-500 tabular-nums leading-none" data-id="element-159">
                        {unit.value}
                      </motion.span>
                      <span className="text-xs md:text-sm text-gray-500 font-medium mt-1 md:mt-2 tracking-widest" data-id="element-160">
                        {unit.label}
                      </span>
                    </div>
                  </Fragment>)}
              </div>

              <div className="flex items-center justify-center gap-2 text-gray-900 mb-6 md:mb-8" data-id="element-161">
                <span className="text-lg md:text-xl" data-id="element-162">⚠️</span>
                <p className="text-base md:text-lg font-semibold" data-id="element-163">
                  Este precio no se va a mantener. Una vez que se agoten los
                  cupos de lanzamiento, el precio sube. No vuelve atrás.
                </p>
              </div>

              <div className="max-w-xl mx-auto" data-id="element-164">
                <div className="flex items-center justify-between mb-2" data-id="element-165">
                  <div className="flex items-center gap-2" data-id="element-166">
                    <span className="w-2.5 h-2.5 rounded-full bg-red-400 animate-pulse" data-id="element-167"></span>
                    <span className="text-sm md:text-base text-red-500 font-medium" data-id="element-168">
                      Cupos al precio de lanzamiento
                    </span>
                  </div>
                  <span className="text-sm md:text-base text-gray-600 font-bold" data-id="element-169">
                    Quedan pocos
                  </span>
                </div>
                <div className="w-full h-3 md:h-4 bg-gray-200 rounded-full overflow-hidden" data-id="element-170">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: `${cuposPercentage}%`
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1.5,
                  ease: 'easeOut'
                }} className="h-full rounded-full" style={{
                  background: 'linear-gradient(90deg, #ef4444 0%, #f97316 70%, #f97316 100%)'
                }} data-id="element-171" />
                </div>
                <p className="text-xs md:text-sm text-gray-500 mt-1.5 text-right" data-id="element-172">
                  {cuposPercentage}% de los cupos ya tomados
                </p>
              </div>
            </div>
          </div>

          <h3 id="elegi-tu-pack" className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6 md:mb-10 scroll-mt-8" data-id="element-173">
            TU ACCESO COMPLETO
          </h3>

          <div className="max-w-2xl mx-auto" data-id="element-174">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-orange-50 border-2 border-orange-400 rounded-lg p-8 relative" data-id="element-175">
              <h4 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-176">
                🍩 MEGA PACK EMPRENDE MINIDONAS 360
              </h4>
              <p className="text-orange-500 font-semibold mb-4" data-id="element-177">
                6 Tomos + 3 Bonos — Masa → Negocio en Pesos
              </p>
              <p className="text-gray-600 text-sm mb-6" data-id="element-178">
                Ideal para cualquier persona que quiera emprender con minidonas
                desde casa, sin experiencia previa
              </p>
              <div className="mb-6" data-id="element-179">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-180">
                  <span className="text-gray-400 line-through text-xl" data-id="element-181">
                    $34.990
                  </span>
                  <span className="text-orange-500 font-bold text-4xl" data-id="element-182">
                    $13.990
                  </span>
                  <span className="text-gray-500" data-id="element-183">ARS</span>
                </div>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48199368966336:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg px-6 py-4 rounded-lg transition-colors shadow-lg shadow-orange-500/20 text-center" data-id="element-184">
                🔴 → QUIERO MI MEGA PACK AHORA
              </motion.a>
              <div className="mt-4 text-center text-sm text-gray-500" data-id="element-185">
                ⭐ Pago 100% seguro · Acceso en 5 minutos · Garantía 7 días
                <br data-id="element-186" />
                Mercado Pago · Tarjeta · Transferencia
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}